import { createServerFn } from "@tanstack/react-start";
import {
  readSidebarPreference,
  writeSidebarPreference,
} from "#/modules/layout/cookie.sidebar.server";

export const getSidebarPreferenceFn = createServerFn({ method: "GET" }).handler(() => {
  return readSidebarPreference();
});

export const setSidebarPreferenceFn = createServerFn({ method: "POST" })
  .validator((data: { open: boolean }) => data)
  .handler(({ data }) => {
    writeSidebarPreference(data.open);
  });
